var map = {
	"./accesorios": 29,
	"./accesorios.js": 29,
	"./auth": 67,
	"./auth.js": 67,
	"./clientes": 31,
	"./clientes.js": 31,
	"./diesel": 36,
	"./diesel.js": 36,
	"./maquinas": 27,
	"./maquinas.js": 27,
	"./obras": 33,
	"./obras.js": 33,
	"./operadores": 28,
	"./operadores.js": 28,
	"./proveedores": 32,
	"./proveedores.js": 32,
	"./traslados": 25,
	"./traslados.js": 25
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 216;